// extracted by mini-css-extract-plugin
export default {"list":"q2WTZx","wrapper":"ET3Uvs","item":"gafOPX","link":"yJPud6","hideOnMobile":"e1fwIq"};